<template>
    <div>
        <template v-if="!status.sent">
            <app-intro class="u-text-center">
                <h2>Wachtwoord vergeten?</h2>
                <p>Dit is het wachtwoord voor mijn.addsoft en het beheerdersaccount van Storec Online. <br/>(mijn.addsoft en Storec Online zijn hetzelfde account)</p>
            </app-intro>

            <form @submit.prevent="handleSubmit" :class="'form' + (theme !== '' ? ' form--' + theme : '')" novalidate >
                <div class="form-fieldset">
                    <div class="form-group" :class="{ 'has-error': submitted && $v.form.email.$error }">
                        <label class="u-sr-only" for="login-email">E-mailadres</label>
                        <input type="email" v-model="form.email" id="login-email" name="emailadres" class="form-control" placeholder="Vul hier je e-mailadres in" />
                        <div v-if="submitted && $v.form.email.$error" class="form-validation">
                            <span v-if="!$v.form.email.required">E-mailadres is verplicht</span>
                            <span v-if="!$v.form.email.email">E-mailadres is ongeldig</span>
                        </div>
                    </div>
                </div>

                <div class="g-cols:1/auto || g-gap:1-xs || u-text-left || align-items-center">
                    <div>
                        <router-link class="form-link" to="/">Terug naar mijn.addsoft</router-link><br/>
                        <a href="https://storec.oudeveldhuis.nl/" class="form-link" target="_blank">Terug naar Storec online</a>
                    </div>

                    <button type="submit" class="[ c-btn c-btn--info ] form-submit-btn" :disabled="status.loggingIn">
                        <span v-show="status.sending"><spinner/></span>
                        <span v-show="!status.sending">Wachtwoord herstellen</span>
                        <svg v-show="!status.loggingIn" xmlns="http://www.w3.org/2000/svg" width="15.589" height="12.389" viewBox="0 0 15.589 12.389">
                            <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                                <path d="M1 6.166h12.875"/>
                                <path d="M8.15 1.4l6.438 4.794-6.438 4.8" stroke-linejoin="round"/>
                                <path d="M8.15 1.399l6.438 4.795-6.437 4.8" stroke-linejoin="round"/>
                            </g>
                        </svg>
                    </button>
                </div>
            </form>
        </template>

        <template v-else>
            <app-intro>
                <h2>E-mail is verstuurd</h2>
                <p>Volg de instructies op in deze e-mail om je wachtwoord te resetten.</p>
            </app-intro>
        </template>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { required, email } from 'vuelidate/lib/validators';
    import normalizeFormData from '../../helpers/normalizeFormData';
    import AppIntro from '../app/AppIntro.vue';
    import Spinner from '../Spinner.vue';

    export default {
        name: 'ForgotPasswordEmailForm',
        components: { Spinner, AppIntro },
        data () {
            return {
                form: {
                    email: '',
                },
                submitted: false,
            };
        },
        props: {
            theme: {
                type: String,
                default: 'light',
            },
        },
        validations: {
            form: {
                email: { required, email },
            },
        },
        computed: {
            ...mapState('account', ['status']),
        },
        methods: {
            ...mapActions('account', ['passwordEmail']),
            async handleSubmit (e) {
                this.submitted = true;

                // validate the form
                this.$v.form.$touch();

                // if its still pending or an error is returned do not submit
                if (this.$v.form.$pending || this.$v.form.$error) return;

                // normalize form data
                const data = normalizeFormData(e.target);

                // login
                await this.passwordEmail(data);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .form-link {
        margin-left: grid(1, sm);
        text-decoration: underline;
    }
</style>
